import { accessRole } from '../../../../helpers/access_role'
import React, { Fragment, Component } from 'react'
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button,
    Fieldset, Legend, Alert
} from "reactstrap"
import { ConfirmAlert } from '../../../../helpers/ui/alert'
import { AvForm, AvGroup, AvInput, AvField, AvCheckboxGroup, AvCheckbox } from "availity-reactstrap-validation"
import { FileInput, generateFormData, Preview } from '../../../../helpers/ui/FileInput'
import Shimmer from "react-shimmer-effect";
import Select from "react-select"
import CustomSelect from '../../../../helpers/ui/CustomSelect'

import { Link, useHistory, Redirect } from "react-router-dom"

import apiResponse from '../../../../services/apiResponse'

import CreateBloc from './Blocs/CreateBloc'
import DatePicker from '../../../../helpers/ui/DatePicker'
import moment from 'moment'

class IndexView extends Component {

    createBloc = new CreateBloc();
    userdata = JSON.parse(localStorage.getItem('userdata'))

    constructor(props) {
        super(props)
        this.state = {
            loadingTitle: "Mengirim data...",
            successInfo: "Data berhasil disimpan",
            dataForm: {},
            dateList: [
                {
                    id: 1,
                    date: ""
                },
            ],
            failedInfo: "Gagal Terjadi Kesalahan",
            minDate: "",
            employeeItems: [],
            employee_wfh_employee_uuid: '',
            employee_wfh_employee_nip: '',
            employee_wfh_employee_name: '',
            employee_wfh_letter_document_uuid: null,
            document: null
        }
    }

    checkNumber = (val) => {

        if (val == '') {
            alert('Mohon isi dulu Nomor ST!')
            return;
        }

        this.setState({
            loading: true,
            loadingTitle: "Mengecek Nomor Surat Tugas...",
            successInfo: "Berhasil",
        })

        this.createBloc.fetchCheckNumber({
            employee_wfh_letter_number: val
        })
    }

    reformatEmployee = (data) => {
        return data.map(function (item) {
            var newObj = {};
            newObj["label"] = (item.employee_nip && item.employee_nip != 0) ? item.employee_nip + " - " + item.employee_full_name : item.employee_full_name;
            newObj["value"] = item.employee_uuid;
            newObj["model"] = item;
            return newObj;
        });
    };

    addDate = () => {
        let count = this.state.dateList.length;
        this.setState({
            dateList: [
                ...this.state.dateList,
                {
                    id: count == 0 ? (count + 1) : this.state.dateList.slice(-1)[0].id + 1,
                    date: "",
                }
            ]
        })

        // console.log(this.state.dateList)
    }

    delDate = (data) => {
        console.log(data)
        this.setState({
            dateList: [
                ...this.state.dateList.filter((val) => val != data)
                // (count-1)
            ]
        })
    }

    handleChangeInputLevel = (e, index) => {
        // 1. Make a shallow copy of the items
        let items = [...this.state.dateList];
        // 2. Make a shallow copy of the item you want to mutate
        let item = { ...items[index] };
        // 3. Replace the property you're intested in
        item.date = e.target.value;
        // 4. Put it back into our array. N.B. we *are* mutating the array here, but that's why we made a copy first
        items[index] = item;
        // 5. Set the state to our new copy
        this.setState({ dateList: items });
    }

    submitData = async () => {
        const dataForm = generateFormData(this.state.dataForm, 'file')
        await this.createBloc.fetchCreate(dataForm)
        // await this.createBloc.fetchCreate(this.state.dataForm)
    }

    handlerOnSubmit = (e, values) => {
        console.log(values)
        if (this.hasDuplicatesValue(values.dates)) {
            alert('Terdapat Tanggal yang sama. Mohon dikoreksi!')
            return
        }

        e.preventDefault()
        this.setState({
            dataForm: {
                ...values,
                is_admin: 1,
                employee_wfh_employee_uuid: this.state.employee_wfh_employee_uuid,
                employee_wfh_employee_nip: this.state.employee_wfh_employee_nip,
                employee_wfh_employee_name: this.state.employee_wfh_employee_name
            },
            confirm: true,
            loadingTitle: "Mengirim data...",
            successInfo: "Data berhasil disimpan"
        })
    }

    checkDate = () => {
        let dates = this.state.dataForm.dates;

        this.createBloc.fetchCheckDate({
            // employee_uuid: this.userdata.employee_uuid,
            employee_uuid: this.state.employee_wfh_employee_uuid,
            dates: dates.join(',')
        })
    }

    hasDuplicatesValue = (array) => {
        return (new Set(array)).size !== array.length;
    }

    confirmResponse = (response) => {
        let forState = {}
        switch (response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                // this.submitData()

                this.checkDate()

                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
            case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:
        }
        this.setState(forState)
    }

    onChangeEmployee = (employee) => {
        var model = employee.model
        console.log(model)


        this.setState({
            employeeSelected: model.employee_uuid,
            employee_wfh_employee_uuid: model.employee_uuid,
            employee_wfh_employee_nip: model.employee_nip,
            employee_wfh_employee_name: model.employee_full_name,

        })
        console.log('xxxx', this.state.employeeSelected);
    }

    componentDidMount() {
        this.createBloc.createChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({
                        loading: false,
                        success: true,
                    });
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    });
                    break
                default:
                    break
            }
        })

        this.createBloc.checkDateChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    let response = result.data.response;
                    this.setState({
                        used_dates_count: response.used_dates_count,
                        used_dates: response.used_dates
                    })

                    if (response.used_dates_count == 0) {
                        this.submitData()
                    } else {
                        this.setState({
                            failedInfo: response.message,
                            loading: false,
                            failed: true,
                        });
                    }
                    break;
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    });
                    break;
                default:
                    break;
            }
        })

        this.createBloc.getMaxDateChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    let response = result.data.response;
                    console.log(response)
                    this.setState({ minDate: response.min_date })
                    break;
                case apiResponse.ERROR:
                    break;
                default:
                    break;
            }
        })
        this.createBloc.fetchMaxDate({ day: 5 })

        this.createBloc.employeeChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if (result.data.status) {
                        let response = result.data.response
                        this.setState({
                            employeeItems: this.reformatEmployee(response.result)
                        })
                    }
                    break
                case apiResponse.ERROR:

                    break
                default:
                    break
            }
        })
        this.createBloc.fetchEmployee()

        this.createBloc.checkNumberChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    let response = result.data.response;

                    if (response != null) {
                        this.setState({
                            employee_wfh_letter_document_uuid: response.employee_wfh_letter_document_uuid,
                            document: response.document_letter,
                            loading: false
                        });
                    } else {
                        this.setState({
                            employee_wfh_letter_document_uuid: null,
                            document: null,
                            loading: false
                        });
                    }
                    break;
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    });
                    break;
                default:
                    break;
            }
        })
    }

    componentWillUnmount() {
        this.createBloc.createChannel?.unsubscribe()
        this.createBloc.checkDateChannel?.unsubscribe()
        this.createBloc.getMaxDateChannel?.unsubscribe()
        this.createBloc.checkNumberChannell?.unsubscribe()
    }

    render() {
        return (
            <Fragment>
                <Container fluid>
                    <Row>
                        <Col className="col-12">

                            <Card>
                                <CardBody>
                                    <CardTitle>Tambah Pengajuan WFH</CardTitle>
                                    <CardSubtitle className="mb-3">
                                        Setiap isian yang bertanda (<span className="text-danger">*</span>) adalah wajib diisi.
                                    </CardSubtitle>
                                    <hr />
                                    <AvForm
                                        className="needs-validation"
                                        onValidSubmit={(e, values) => this.handlerOnSubmit(e, values)}
                                    >

                                        <Alert color="info" role="alert">
                                            <p><strong> Work from Home (WFH)</strong></p>
                                            <ul>
                                                <li>Pegawai yang mendapat penugasan WFH, wajib menyampaikan rencana dan laporan hasil WFH.</li>
                                                <li>Pegawai yang mendapat penugasan WFH, tetap memperoleh uang makan dan tunjangan kinerja selama memenuhi ketentuan WFH.</li>
                                                <li>Ketentuan WFH :<ol>
                                                    <li>Pegawai membuat Surat Tugas (ST)/Surat Keterangan WFH melalui aplikasi persuratan atau di luar aplikasi persuratan.</li>
                                                    <li>ST/Surat Keterangan WFH ditandatangani (DS atau tanda tangan basah) oleh pejabat yang berwenang sesuai ketentuan.</li>
                                                    <li>Untuk pencatatan di Kepegawaian, pegawai menyampaikan rencana WFH dengan melampirkan ST/Surat Keterangan <strong>paling lambat bersamaan</strong> dengan tanggal WFH.</li>
                                                    <li>Pada saat jadwal WFH, pegawai dapat melakukan presensi mobile dimana pun (Masuk dan Pulang).</li>
                                                    <li>Jika terdapat perubahan jadwal WFH menjadi WFO maka pegawai cukup melakukan presensi di kantor.</li>
                                                    <li><strong>Hasil presensi mobile tidak otomatis tercatat sebagai kehadiran pegawai, sampai pegawai menyampaikan laporan WFH</strong>.</li>
                                                    <li>Pegawai menyampaikan laporan WFH kepada atasan langsung.</li>
                                                    <li>Atasan langsung memverifikasi laporan WFH.</li>
                                                    <li>Jika laporan WFH disetujui, maka presensi mobile akan tercatat sebagai kehadiran pegawai.</li>
                                                    <li>Jika tidak disetujui, maka pegawai dianggap tidak hadir.</li>
                                                    <li>Laporan WFH disusun dan disampaikan kepada atasan langsung secara harian.</li>
                                                    <li>Atasan Langsung dapat memverifikasi Laporan WFH paling lambat pada akhir bulan berjalan.</li>
                                                </ol></li></ul>
                                        </Alert>

                                        <Alert color="info" role="alert">
                                            <p>
                                                <strong>SURAT KETERANGAN WFH</strong> <br />
                                                Surat Keterangan WFH digunakan ketika ketentuan WFO maksimal 100% (Yang diberikan WFH hanya pegawai dengan kondisi tertentu). Ditandatangani oleh Eselon I
                                                <br />
                                                <a href={process.env.REACT_APP_SERVICE_CORE_URL + "/templates/Surat_Keterangan_WFH.docx"} target="_blank" rel="noreferrer">
                                                    Unduh template...
                                                </a>
                                            </p>
                                        </Alert>

                                        <Alert color="info" role="alert">
                                            <p>
                                                <strong>SURAT TUGAS WFH</strong> <br />
                                                Surat Tugas WFH digunakan ketika ketentuan WFO kurang dari 100% (Wfo 75%, 50 %, 25%) Semua pegawai memiliki hak untuk menerima penugasan WFH. Ditandatangani oleh Eselon II
                                                <br />
                                                <a href={process.env.REACT_APP_PERSURATAN_URL + "/outbox/daftardraft.html?create"} target="_blank" rel="noreferrer">
                                                    Buat Surat Tugas (Klik Disini)
                                                </a>
                                            </p>
                                        </Alert>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                                Pilih Pegawai <span className="text-danger">*</span>
                                            </label>
                                            <Col md="5">
                                                <Select
                                                    value={this.state.employeeItems.filter(
                                                        (option) =>
                                                            option.value === this.state.employeeSelected
                                                    )}
                                                    onChange={this.onChangeEmployee}
                                                    options={this.state.employeeItems}
                                                    classNamePrefix=""
                                                    placeholder="Pilih Pegawai"
                                                // isLoading={this.state.isLoadingOptEmployee}
                                                />
                                                <AvField
                                                    name="employee_uuid"
                                                    type="hidden"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="employee_uuid"
                                                    value={this.state.employeeSelected}
                                                    errorMessage="Pilih Pegawai"
                                                />
                                                {/* <CustomSelect
                                                    value={this.state.employeeItems.filter(option => option.value === this.state.employeeSelected)}
                                                    onChange={
                                                        this.onChangeEmployee
                                                    }
                                                    name="employee_by_admin"
                                                    required="required"
                                                    options={this.state.employeeItems}
                                                    defaultValue={this.state.employeeSelected}
                                                    classNamePrefix=""
                                                    placeholder="Pilih Pegawai"
                                                    errorMessage="Masukkan Pegawai"
                                                    validate={{ required: { value: true } }}
                                                /> */}
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="employee_wfh_letter_number"
                                                className="col-md-3 col-form-label"
                                            >
                                                Nomor Surat Keterangan WFH <span className="text-danger">*</span>
                                            </label>
                                            <Col md="3">
                                                <AvField
                                                    name="employee_wfh_letter_number"
                                                    placeholder="Nomor Surat Keterangan WFH..."
                                                    type="text"
                                                    errorMessage="Masukkan Nomor Surat Keterangan WFH"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="employee_wfh_letter_number"
                                                />
                                            </Col>
                                            <Col md="3">
                                                <Button className="btn-block waves-effect waves-light mb-1 btn btn-primary"
                                                    color="primary"
                                                    type="button"
                                                    onClick={() => {
                                                        this.checkNumber(document.getElementById('employee_wfh_letter_number').value)
                                                    }}
                                                >Cek Nomor
                                                </Button>
                                            </Col>
                                        </Row>

                                        {
                                            this.state.employee_wfh_letter_document_uuid == null ?
                                                <Row className="mb-3">
                                                    <label
                                                        className="col-md-3 col-form-label"
                                                    >
                                                        Upload Surat Keterangan/Surat Tugas WFH <span className="text-danger">*</span>
                                                    </label>
                                                    <Col md="3">
                                                        <FileInput
                                                            name="file"
                                                            placeholder="Upload Surat Keterangan"
                                                            className="form-control"
                                                            validate={{ required: { value: true } }}
                                                            col="6"
                                                        />
                                                    </Col>
                                                </Row>
                                                :
                                                <Row className="mb-3">
                                                    <label
                                                        className="col-md-3 col-form-label"
                                                    >
                                                        Surat Keterangan/Surat Tugas WFH Sudah Tersedia
                                                    </label>
                                                    <Col md="6">
                                                        <Preview value={this.state.document} />
                                                        <AvField
                                                            name="employee_wfh_letter_document_uuid"
                                                            type="hidden"
                                                            value={this.state.employee_wfh_letter_document_uuid}
                                                            id="employee_wfh_letter_document_uuid"
                                                        />
                                                    </Col>
                                                </Row>
                                        }

                                        <hr />

                                        <Row className="mb-3">
                                            <label
                                                className="col-md-3 col-form-label"
                                            >
                                                Tanggal WFH <span className="text-danger">*</span>
                                            </label>
                                            <Col md="3">

                                                {
                                                    this.state.dateList.map((data, index) => {
                                                        return (
                                                            <div className="row" key={`in-${index}`}>
                                                                <div className="col-md-10">
                                                                    {
                                                                        this.state.minDate == "" ?
                                                                            <Shimmer>
                                                                                <div style={{ width: "100%", height: 40 }}></div>
                                                                            </Shimmer>
                                                                            :
                                                                            <DatePicker
                                                                                name={`dates[${index}]`}
                                                                                isWeekday={true}
                                                                                dateFormat="dd/MM/yyyy"
                                                                                errorMessage="Masukan Tanggal"
                                                                                validate={{ required: { value: true } }}
                                                                            // minDate={moment().add(5, 'days').format('YYYY-MM-DD')}
                                                                            // minDate={this.state.minDate}
                                                                            />
                                                                    }
                                                                </div>
                                                                <div className="col-md-2 text-right">
                                                                    {
                                                                        index == 0 ?
                                                                            <div className="col-md-2 text-right">
                                                                                <Button className="btn-block waves-effect waves-light mb-1 btn btn-primary"
                                                                                    color="success"
                                                                                    type="button"
                                                                                    onClick={this.addDate}
                                                                                ><i className="uil-plus-circle"></i>
                                                                                </Button>
                                                                            </div> :
                                                                            <Button className="btn-block waves-effect waves-light mb-1 btn btn-primary"
                                                                                color="danger"
                                                                                type="button"
                                                                                onClick={() => {
                                                                                    this.delDate(data)
                                                                                }}
                                                                            ><i className="uil-trash-alt"></i>
                                                                            </Button>
                                                                    }

                                                                </div>
                                                            </div>
                                                        )
                                                    })
                                                }
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <Col md="3"></Col>
                                            <Col md="9">
                                                <Link to="?">
                                                    <Button color="danger"><i className="uil-arrow-left"></i> Kembali</Button>
                                                </Link>
                                                {' '}
                                                <Button color="success" type="submit">
                                                    <i className="uil-arrow-up-right"></i> Simpan Data
                                                </Button>
                                            </Col>
                                        </Row>
                                    </AvForm>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin akan menyimpan data ini?"

                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"

                    successTitle="Berhasil!"
                    successInfo="Data berhasil disimpan"

                    failedTitle="Gagal!"
                    failedInfo={this.state.failedInfo}

                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}

                    response={this.confirmResponse}
                />
                {this.state.redirect ?
                    <Redirect to='/kepegawaian/pengajuan_wfh.html?' />
                    : null}
            </Fragment>
        )
    }

}

export default IndexView